import axios from 'axios';

// Consulta de CNPJ pelo backend (/clientes/consulta-cnpj), que usa APIs públicas gratuitas
// (BrasilAPI, com MinhaReceita e ReceitaWS de reserva) e mantém cache.
// Retorna { dados } com os campos do cadastro de cliente, ou { erro } com a mensagem para o usuário.
// Nunca lança: o preenchimento automático não pode bloquear o cadastro manual.
export async function consultarCnpj(cnpj, apiBaseUrl, authHeader) {
  const numeros = (cnpj || '').replace(/\D/g, '');
  if (numeros.length !== 14) return { erro: 'CNPJ inválido' };

  try {
    const { data } = await axios.get(`${apiBaseUrl}/clientes/consulta-cnpj/${numeros}`, {
      ...authHeader,
      timeout: 30000,
    });
    return { dados: data };
  } catch (error) {
    console.error('Erro ao consultar CNPJ:', error);
    const mensagem = error.response?.data?.message;
    return { erro: mensagem || 'Não foi possível consultar o CNPJ. Preencha os dados manualmente.' };
  }
}

const ROTULOS_CAMPOS_CNPJ = {
  nome: 'nome', email: 'e-mail', telefone: 'telefone', cep: 'CEP', logradouro: 'endereço', numero: 'número',
  complemento: 'complemento', bairro: 'bairro', cidade: 'cidade', uf: 'UF',
};

// Edição de cliente (cadastro antigo/incompleto): completa só os campos em branco com os dados do CNPJ,
// sem apagar nem trocar o que já está preenchido. Devolve o formulário novo e os rótulos do que foi completado.
export function completarComDadosCnpj(atual, dados) {
  const novo = { ...atual };
  const completados = [];
  Object.keys(dados || {}).forEach(campo => {
    const valorAtual = String(atual[campo] ?? '').trim();
    if (!valorAtual && dados[campo]) {
      novo[campo] = dados[campo];
      completados.push(ROTULOS_CAMPOS_CNPJ[campo] || campo);
    }
  });
  return { novo, completados };
}

// Mensagem do toast depois de completar a edição pelo CNPJ
export function avisoCompletarCnpj(completados) {
  return completados.length > 0
    ? { tipo: 'success', texto: `Completado pelo CNPJ: ${completados.join(', ')}. Os demais campos foram mantidos.` }
    : { tipo: 'warning', texto: 'Nada a completar: os campos que o CNPJ traz já estão preenchidos.' };
}
